import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-success-online-exam',
  templateUrl: './success-online-exam.component.html',
  styleUrl: './success-online-exam.component.scss'
})
export class SuccessOnlineExamComponent {

  @Input() result: {
    totalMarks: number;
    obtainedMarks: number;
    passMarks: number;
    percentage: number;
    isPass: false;
    attemptsLeft: number;
    resultFail:string;
    resultSuccess:string;
   show_total_marks: string;      
  show_pass_marks: string;        
  show_percentage: string;        
  show_results_status: string;   
  check_result_status: string;   
  show_result: string;   
  };

  @Output() retake = new EventEmitter<void>();
   @Input() candidateName!: string; // ✅ add this line
   @Output() verify = new EventEmitter<void>();

  retakeExam() {
    this.retake.emit(); // notify parent to reset exam
  }

 closeResult() {
  window.open('https://whiterobe.in/');
}

 // ✅ Decode encoded HTML (e.g., &lt;p>Better luck next time&lt;/p>)
  decodeHtml(encoded: string): string {
    if (!encoded) return '';
    const txt = document.createElement('textarea');
    txt.innerHTML = encoded;
    return txt.value;
  }

}
